import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { IndividualWebhookEndpoint } from './getWebhookEndpoints';

export interface DeleteWebhookEndpointPayload {
  configId: number;
  businessId: number;
}
export interface EditWebhookEndpointPayload extends DeleteWebhookEndpointPayload {
  webhookEndpoint: string;
}

export const editWebhookEndpoint = ({
  configId,
  webhookEndpoint,
  businessId,
}: EditWebhookEndpointPayload): AxiosPromise<IndividualWebhookEndpoint> => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/businesses/${businessId}/integrations/configs/${configId}`,
    data: {
      webhookEndpoint,
    },
  });
};

export const deleteWebhookEndpoint = ({
  configId,
  businessId,
}: DeleteWebhookEndpointPayload): AxiosPromise<IndividualWebhookEndpoint> => {
  return httpClient({
    method: 'DELETE',
    url: `/super-admin/businesses/${businessId}/integrations/configs/${configId}`,
  });
};
